import React, { memo, ReactNode } from 'react'

import styled from '@emotion/styled'

import { Box } from '@surglogs-app/ui'

export const MAX_MODAL_HEIGHT = '80vh'
export const MAX_MODAL_WIDTH = '1000px'

export type ModalSize = 'default' | 'wide'

const Wrapper = styled(Box)<{ size?: ModalSize }>`
  position: relative;
  background-color: ${({ theme }) => theme.ui.colors['white.100']};
  border-radius: ${({ theme }) => theme.ui.spacings.md};
  margin: 0 auto;
  max-width: ${({ theme, size }) =>
    size === 'wide' ? MAX_MODAL_WIDTH : theme.maxWidth.md};

  @media ${({ theme }) => theme.mq.md} {
    max-width: 100%;
  }
`

const Content = styled(Box)`
  width: 100%;
  overflow-y: auto;
  max-height: ${MAX_MODAL_HEIGHT};
`

type EP = Omit<React.ComponentProps<typeof Wrapper>, 'children'>
type ModalContentProps = EP & { children: ReactNode | ReactNode[] }

export const ModalContent = memo(
  ({ children, size = 'default', ...rest }: ModalContentProps) => (
    <Wrapper {...{ ...rest, size }}>
      <Content {...{ 'aria-label': 'dialog-content' }}>{children}</Content>
    </Wrapper>
  ),
)
